export default __webpack_public_path__ + "static/wholesalersVp5-676667c17b0e0ad4549ca56f36d8456a.png";